"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));
var _i18n = require("../../../../Framework/i18n");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _upperFirst = _interopRequireDefault(require("lodash/upperFirst"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _AddCircle = _interopRequireDefault(require("@material-ui/icons/AddCircle"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _MainButton = _interopRequireDefault(require("../../../../Shared/Components/MainButton"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _PlusMinusInput = require("../PlusMinusInput");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var styles = function styles(theme) {
  return {
    dialogTitleRoot: {
      padding: '12px 12px 20px 30px',
      fontWeight: 400,
      borderTop: '7px solid ' + theme.palette.primary.main
    },
    dialogContentRoot: {
      padding: '0 32px 24px 30px'
    },
    TypographyCaption: {
      lineHeight: 2.7
    },
    CloseIcon: {
      position: 'absolute',
      right: 30,
      top: 30,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    activeButton: {
      margin: '0 30px 16px 0',
      padding: '10px 24px'
    },
    addButton: {
      textTransform: 'none'
    },
    selectedVariant: {
      maxWidth: 150,
      width: '100%',
      height: 'auto',
      objectFit: 'contain'
    },
    textFieldBulkName: {
      width: 'calc(100% - 24px)'
    },
    buttonStyle: {
      color: theme.buttons.mainBtn.backgroundColor
    },
    rootIconButton: {
      padding: '12px 0'
    },
    variantLabel: {
      color: theme.palette.secondary.dark,
      fontSize: '15px',
      lineHeight: 2.1
    },
    addButtonGrid: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 24
    },
    textInput: {
      display: 'flex',
      marginTop: 24
    },
    textInputProp: {
      height: 10
    },
    textInputLabel: {
      transform: 'translate(14px, 14px) scale(1)'
    },
    newBulkName: {
      fontWeight: 'bold',
      lineHeight: 1,
      padding: '0 5px'
    },
    gridItem: {
      paddingRight: 15
    }
  };
};
var BulkNames = /*#__PURE__*/function (_React$Component) {
  _inherits(BulkNames, _React$Component);
  var _super = _createSuper(BulkNames);
  function BulkNames() {
    _classCallCheck(this, BulkNames);
    return _super.apply(this, arguments);
  }
  _createClass(BulkNames, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        width = _this$props.width,
        onClose = _this$props.onClose,
        showBulkNameForm = _this$props.showBulkNameForm,
        amountLabel = _this$props.amountLabel,
        selectedVariant = _this$props.selectedVariant,
        activeSizeVariant = _this$props.activeSizeVariant,
        totalAmount = _this$props.totalAmount,
        textInputs = _this$props.textInputs,
        handleDelete = _this$props.handleDelete,
        addTextField = _this$props.addTextField,
        handleText = _this$props.handleText,
        saveConfigurationBulkNames = _this$props.saveConfigurationBulkNames,
        size = _this$props.size;
      return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
        open: showBulkNameForm,
        onClose: onClose,
        maxWidth: 'sm',
        fullWidth: true,
        fullScreen: width === 'sm' || width === 'xs',
        scroll: "paper"
      }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
        className: classes.dialogTitleRoot
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: classes.TypographyCaption,
        variant: "body1"
      }, /*#__PURE__*/_react["default"].createElement("b", null, (0, _i18n.t)('bulkNames.bulkNamesEdit'))), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: classes.CloseIcon,
        onClick: onClose
      }, "close")), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
        className: classes.dialogContentRoot
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 3,
        className: classes.gridItem
      }, selectedVariant.url && /*#__PURE__*/_react["default"].createElement("img", {
        src: selectedVariant.url,
        alt: selectedVariant.title,
        "aria-label": selectedVariant.title,
        className: classes.selectedVariant
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 9
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        classes: {
          root: classes.variantLabel
        }
      }, /*#__PURE__*/_react["default"].createElement("b", null, (0, _upperFirst["default"])(selectedVariant.title))), !(0, _isEmpty["default"])(activeSizeVariant) && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        classes: {
          root: classes.variantLabel
        }
      }, (0, _i18n.t)('bulkNames.size'), /*#__PURE__*/_react["default"].createElement("b", null, size)), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        classes: {
          root: classes.variantLabel
        }
      }, (0, _i18n.t)('bulkNames.amount'), /*#__PURE__*/_react["default"].createElement("b", null, totalAmount()))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12
      }, textInputs.map(function (text, index) {
        return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          container: true,
          key: index,
          className: classes.textInput
        }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 8
        }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
          id: toString(index),
          className: classes.textFieldBulkName,
          label: (0, _i18n.t)('bulkNames.name'),
          value: text.text,
          onChange: handleText('text', index),
          variant: "outlined",
          InputLabelProps: {
            classes: {
              outlined: classes.textInputLabel
            }
          },
          InputProps: {
            classes: {
              input: classes.textInputProp
            },
            endAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
              position: "end"
            }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
              "aria-label": (0, _i18n.t)('bulkNames.deleteBulkName'),
              onClick: handleDelete(index),
              classes: {
                label: classes.buttonStyle,
                root: classes.rootIconButton
              }
            }, /*#__PURE__*/_react["default"].createElement(_Delete["default"], null)))
          }
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 4
        }, /*#__PURE__*/_react["default"].createElement(_PlusMinusInput.PlusMinusInput, {
          maxSize: 9999,
          minSize: 1,
          amountLabel: amountLabel,
          value: text.amount,
          onChangeValue: handleText('amount', index)
        })));
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        className: classes.addButtonGrid
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: classes.addButton,
        onClick: addTextField
      }, /*#__PURE__*/_react["default"].createElement(_AddCircle["default"], null), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        classes: {
          root: classes.newBulkName
        }
      }, (0, _i18n.t)('bulkNames.addNewBulkName')))))), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_MainButton["default"], {
        onClick: saveConfigurationBulkNames,
        variant: "contained",
        size: "medium",
        className: classes.activeButton
      }, (0, _i18n.t)('bulkNames.apply'))));
    }
  }]);
  return BulkNames;
}(_react["default"].Component);
var _default = exports["default"] = (0, _withWidth["default"])()((0, _styles.withStyles)(styles, {
  name: 'BulkNames'
})(BulkNames));